import { createVanIconComponent } from "./van"

const HotOutlined = createVanIconComponent("hot-o")
export default HotOutlined
